// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"493":"2183683c","504":"bda6baae"}[chunkId] + ".chunk.js";
};